/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/

export enum PeriodBundlesStatusEnum {
    OPEN = 'OPEN',
    CLOSED = 'CLOSED',
    TOTAL = 'TOTAL',
}
